// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bv-example-row .row>.col[data-v-afdc2df6]:not(.header),.bv-example-row .row>[class^=col-][data-v-afdc2df6]{padding-top:.75rem;padding-bottom:.75rem;background-color:rgba(86,61,124,.15);border:1px solid rgba(86,61,124,.2)}", ""]);
// Exports
module.exports = exports;
